import React,{Component} from 'react';
import {withRouter} from "react-router-dom";
import './experience.css';
import {alertLabels, labels, messages} from "../../util/constants";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPenSquare, faArrowLeft, faSave, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {
    getSessionState, removeTokenUserStorage, setAlertOnRedux, showLoading,
    validRemoveTokenUserStorage
} from "../../actions";
import {Button} from "@material-ui/core/umd/material-ui.production.min";
import MultiSelectField from "../../components/multiSelect/multiSelect";
import {parseToKeyValueToResponse} from "../../util/tools";
import httpHttpsRequest from '../../util/http-request/request';
import { getComponentGroupOptions, getClaimedOptions, getAnomalyOptions, getExperienceOptions, postExperienceOptions, deleteExperienceOptions } from '../../util/optionsRequest';

class Experience extends Component{

    constructor(props){
        super(props);

        this.state={
            experience : [],
            groupData : [],
            claimedData: [],
            anomalyData: [],
            groupSelected: [],
            claimedSelected:[],
            anomalySelected:[],
            revisionDescription: [],
        }
    }

    componentWillMount (){
        this.getDataExperience();
    };

    getDataGroups= () => {
        showLoading(true);

        let http = new httpHttpsRequest(getComponentGroupOptions);

        http.makeRequest().then((data) => {
            this.groupsSuccess(JSON.parse(data));
        }).catch((data) => {
            this.callBackError(data);
        });

        showLoading(false);
    };

    groupsSuccess = (response) =>{
        try {
            let groupsKeyValue = parseToKeyValueToResponse(response.data,'id_group', 'group_name_pt');
            this.setState({groupData: groupsKeyValue});
            this.getDataClaimed();
        } catch (err) {
            setAlertOnRedux(true,alertLabels.iconError,messages.requestErrorDefault, alertLabels.alertDanger);
        }
    };

    getDataClaimed = () => {
        showLoading(true);

        let param = {'id_group':this.state.groupSelected.value};
        let http = new httpHttpsRequest(getClaimedOptions);
        http.addQueryString(param);

        http.makeRequest().then((data) => {
            this.claimedSuccess(JSON.parse(data))
        }).catch((data) => {
            this.callBackError(data)
        });

        showLoading(false);
    };

    claimedSuccess = (response) => {
        try {
            let claimedKeyValue = parseToKeyValueToResponse(response.data,'id_claimed', 'claimed_name_pt');
            this.setState({claimedData: claimedKeyValue});

           this.getDataAnomaly();
        } catch (err) {
            setAlertOnRedux(true,alertLabels.iconError,messages.requestErrorDefault, alertLabels.alertDanger);
        }
    };

    getDataAnomaly= () => {
        showLoading(true);

        let param = {'id_claimed':this.state.claimedSelected.value};
        let http = new httpHttpsRequest(getAnomalyOptions);
        http.addQueryString(param);

        http.makeRequest().then((data) => {
            this.anomalySuccess(JSON.parse(data))
        }).catch((data) => {
            this.callBackError(data)
        });

        showLoading(false);
    };

    anomalySuccess = (response) => {
        try {
            let anomalyKeyValue = parseToKeyValueToResponse(response.data,'id_anomaly_private', 'anomaly_name_pt');
            this.setState({anomalyData: anomalyKeyValue});
        } catch (err){
            setAlertOnRedux(true,alertLabels.iconError,messages.requestErrorDefault, alertLabels.alertDanger);
        }
    };

    getDataExperience = () => {
        if (this.props.location != null && this.props.location.params != null){
            let params = {
                id_experience: this.props.location.params.id_experience,
                profile_type: this.props.location.params.profile_type
            };
            let http = new httpHttpsRequest(getExperienceOptions);
            http.addQueryString(params);

            http.makeRequest().then((data)=>{this.experienceSuccess(JSON.parse(data))})
                .catch((data)=>{this.callBackError(data)})
        } else {
            this.props.history.goBack();
        }
    };

    experienceSuccess = (response) => {
        if(response.data && response.data.length > 0){
            this.setState({experience:response.data[0]});

            let groupExperience = {value:this.state.experience.id_group, label:this.state.experience.group_name_pt};
            let claimedExperience = {value:this.state.experience.id_claimed, label:this.state.experience.claimed_name_pt};
            let anomalyExperience = {value:this.state.experience.id_anomaly_private, label:this.state.experience.anomaly_name_pt};
            let revisionDescriptionExperience = this.state.experience.revision_description;

            this.setState({groupSelected: groupExperience});
            this.setState({claimedSelected: claimedExperience});
            this.setState({anomalySelected: anomalyExperience});
            this.setState({revisionDescription: revisionDescriptionExperience});

            this.getDataGroups();
        } else {
            this.props.history.goBack();
        }
    };

    saveReview = () => {
        let params = {
            'id_experience': this.state.experience.id_experience,
            'profile_type': this.state.experience.profile_type,
            'id_user': getSessionState().userLogged,
            'revision_description': this.state.revisionDescription,
            'id_anomaly_private': this.state.anomalySelected.value
        };

        let http = new httpHttpsRequest(postExperienceOptions);
        http.addRequestBody(params);

        http.makeRequest().then((data)=>{this.saveReviewSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)});
    };

    saveReviewSuccess = (response) =>{
        try{
            if(response != null && response.success == true){
                this.props.history.goBack();
                setAlertOnRedux(true,alertLabels.iconSuccess,messages.experienceReviewed, alertLabels.alertSuccess);
            }else{
                setAlertOnRedux(true,alertLabels.iconError,response.message, alertLabels.alertDanger);
            }
        }catch(err){
            setAlertOnRedux(true,alertLabels.iconError,response.requestErrorDefault, alertLabels.alertDanger);
        }
    };

    cancelExperience = () =>{
        let confirmCancel = window.confirm(messages.confirmCancelExperience);

        if(confirmCancel){
            let params = {
                'id_experience': this.state.experience.id_experience,
                'profile_type': this.state.experience.profile_type,
                'id_user': getSessionState().userLogged
            };

            let http = new httpHttpsRequest(deleteExperienceOptions);
            http.addQueryString(params);

            http.makeRequest().then((data)=>{this.cancelExperienceSuccess(JSON.parse(data))})
                .catch((data)=>{this.callBackError(data)});
        }
    };

    cancelExperienceSuccess = (response) =>{
        try{
            if(response != null && response.success == true){
                this.props.history.goBack();
                setAlertOnRedux(true,alertLabels.iconSuccess,messages.experienceCanceled, alertLabels.alertSuccess);
            }else{
                setAlertOnRedux(true,alertLabels.iconError,response.message, alertLabels.alertDanger);
            }
        }catch(err){
            setAlertOnRedux(true,alertLabels.iconError,response.requestErrorDefault, alertLabels.alertDanger);
        }
    };

    callBackError = (response) => {
        try {
            if (validRemoveTokenUserStorage(response.statusCode)) {
                removeTokenUserStorage();
            }
            setAlertOnRedux(true, alertLabels.iconError, JSON.parse(response.body).message, alertLabels.alertDanger);
        }catch(err){
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger);
        }
    };

    changeGroup = (groupSelected) => {
        if(groupSelected){
            this.setState({groupSelected},()=>{
                this.setState({claimedSelected:[]});
                this.setState({anomalySelected:[],anomalyData:[]});
                this.getDataClaimed();
            });
        }
        else{
            this.setState({groupSelected:[]},()=>{
                this.setState({claimedSelected:[]});
                this.setState({anomalySelected:[],anomalyData:[]});
                this.getDataClaimed();
            });
        }
    };

    changeClaimed = (claimedSelected) => {
        if(claimedSelected){
            this.setState({claimedSelected}, ()=>{
                this.setState({anomalySelected:[]});
                this.getDataAnomaly();
            });
        }
        else{
            this.setState({claimedSelected:[]},()=>{
                this.setState({anomalySelected:[]});
                this.getDataAnomaly();
            });
        }
    };

    changeAnomaly = (anomalySelected) => {
        if(anomalySelected){
            this.setState({anomalySelected});
        }
        else{
            this.setState({anomalySelected:[]});
        }
    };

    changeDescription = (value) =>{
        this.setState({ revisionDescription: value });
    };

    validShowButtonSave = () =>{
        if(this.state.groupSelected && this.state.groupSelected.value
            && this.state.claimedSelected && this.state.claimedSelected.value
            && this.state.anomalySelected && this.state.anomalySelected.value
            && this.state.revisionDescription && this.state.revisionDescription.length > 0){
           return (<Button variant="contained" style={{marginRight: '2%'}} color="primary" onClick={()=>{this.saveReview()}}>
                <FontAwesomeIcon icon={faSave}/> &nbsp;&nbsp;{labels.saveReview}
            </Button>);
        }
    }

    render(){
        return(
            <div>
                <h1 className='title'>{'\u00A0'} <FontAwesomeIcon icon={faPenSquare} />{'\u00A0'} {labels.experiencesReview}</h1>
                <div className="div-margin-top fieldset-experience form-group">
                    <Row className="fieldset-board" >
                        <Col className="col-md-2">
                            <FormGroup>
                                <Label for="registration">{labels.registration}</Label>
                                <Input type='text' name="registration" id="registration" disabled
                                       value={this.state.experience.id_user}/>
                            </FormGroup>
                        </Col>
                        <Col className="col-md-3">
                            <FormGroup>
                                <Label for="name">{labels.name}</Label>
                                <Input type='text' name="name" id="name" disabled
                                       value={this.state.experience.user_name}/>
                            </FormGroup>
                        </Col>
                        <Col className="col-md-3">
                            <FormGroup>
                                <Label for="userEmail">{labels.userEmail}</Label>
                                <Input type='text' name="userEmail" id="userEmail" disabled
                                       value={this.state.experience.user_email}/>
                            </FormGroup>
                        </Col>
                        <Col className="col-md-2">
                            <FormGroup>
                                <Label for="userCResp">{labels.userCResp}</Label>
                                <Input type='text' name="userCResp" id="userCResp" disabled
                                       value={this.state.experience.user_cresp}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="fieldset-board" >
                        <Col className="col-md-2">
                            <FormGroup>
                                <Label for="license_plate">{labels.plateVehicle}</Label>
                                <Input type='text' name="license_plate" id="license_plate" disabled
                                       value={this.state.experience.license_plate}/>
                            </FormGroup>
                        </Col>
                        <Col className="col-md-2">
                            <FormGroup>
                                <Label for="model_car">{labels.model}</Label>
                                <Input type='text' name="model_car" id="model_car" disabled
                                       value={this.state.experience.model_car}/>
                            </FormGroup>
                        </Col>
                        <Col className="col-md-3">
                            <FormGroup>
                                <Label for="model_year">{labels.year}</Label>
                                <Input type='text' name="model_year" id="model_year" disabled
                                       value={this.state.experience.model_year}/>
                            </FormGroup>
                        </Col>
                        <Col className="col-md-3">
                            <FormGroup>
                                <Label for="fuel_type">{labels.fuelType}</Label>
                                <Input type='text' name="fuel_type" id="fuel_type" disabled
                                       value={this.state.experience.fuel_type}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="fieldset-board" >
                        <Col className="col-md-2">
                            <FormGroup>
                                <Label for="market">{labels.market}</Label>
                                <Input type='text' name="market" id="market" disabled
                                       value={this.state.experience.market}/>
                            </FormGroup>
                        </Col>
                        <Col className="col-md-2">
                            <FormGroup>
                                <Label for="profile_type">{labels.profile}</Label>
                                <Input type='text' name="profile_type" id="profile_type" disabled
                                       value={this.state.experience.profile_type}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="fieldset-board" >
                        <Col className="col-md-3">
                            <label >
                                {labels.groups}
                            </label>
                            <MultiSelectField id="multiSelectGroup" data={this.state.groupData} multi={false} handleSelectChange={this.changeGroup}
                                              valuesSelected={this.state.groupSelected} placeHolder={labels.selectGroupPlaceHolder} />
                        </Col>
                        <Col className="col-md-3">
                            <label >
                                {labels.claimedItem}
                            </label>
                            <MultiSelectField id="multiSelectClaimed" data={this.state.claimedData} multi={false} handleSelectChange={this.changeClaimed}
                                              valuesSelected={this.state.claimedSelected} placeHolder={labels.selectSubGroupPlaceHolder} />
                        </Col>
                        <Col className="col-md-3">
                            <label >
                                {labels.anomaly}
                            </label>
                            <MultiSelectField id="multiSelectAnomaly" data={this.state.anomalyData} multi={false} handleSelectChange={this.changeAnomaly}
                                              valuesSelected={this.state.anomalySelected} placeHolder={labels.selectAnomalyPlaceHolder} />
                        </Col>
                    </Row>
                    <Row className="fieldset-board" >
                        <Col className="col-md-2">
                            <FormGroup>
                                <Label for="status">{labels.status}</Label>
                                <Input type='text' name="status" id="status" disabled
                                       value={this.state.experience.status_label}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="fieldset-board" >
                        <Col className="col-md-12">
                            <FormGroup>
                                <Label for="original_description">{labels.originalDescription}</Label>
                                <Input type="textarea" name="original_description" id="original_description" disabled
                                       value={this.state.experience.original_description}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="fieldset-board" >
                        <Col className="col-md-12">
                            <FormGroup>
                                <Label for="revision_description">{labels.revisionDescription}</Label>
                                <Input type="textarea" name="revision_description" id="revision_description" onChange={evt => this.changeDescription(evt.target.value)}
                                       value={this.state.revisionDescription}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="fieldset-board" >
                        <Col className="col-md-6">
                            <Button variant="contained"  style={{marginRight: '2%'}} color="secondary" onClick={()=>{this.cancelExperience()}}>
                                <FontAwesomeIcon icon={faTrashAlt}/> &nbsp;&nbsp;{labels.cancelExperience}
                            </Button>
                        </Col>
                        <Col className="col-md-6 align-right">
                            <Button variant="contained" style={{marginRight: '2%', color: '#FFF', background: '#888'}} onClick={()=>{this.props.history.goBack();}}>
                                <FontAwesomeIcon icon={faArrowLeft}/> &nbsp;&nbsp;{labels.back}
                            </Button>
                            {this.validShowButtonSave()}
                        </Col>
                    </Row>
                </div>
            </div>

        )
    }
}

export default withRouter(Experience);


// WEBPACK FOOTER //
// ./src/containers/experiences/experience.js